import { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { LinkTemplate } from "./SocialNetworkHelpers";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { ISOLogoTemplate } from "./ISOCountryLogoList";

const IndexTable = ({ data, searchEnabled, longDescription }) => {
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState("");

  useEffect(() => {
    initFilters1();
  }, []);

  const initFilters1 = () => {
    setFilters1({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    setGlobalFilterValue1("");
  };

  const renderHeader1 = () => {
    if (searchEnabled) {
      return (
        <div className="flex justify-content-end">
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search"> </InputIcon>
            <InputText
              value={globalFilterValue1}
              onChange={onGlobalFilterChange1}
              placeholder="Keyword search"
            />
          </IconField>
        </div>
      );
    }
  };

  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = { ...filters1 };
    _filters1["global"].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  };

  const header1 = renderHeader1();

  const IndexISOLogoTemplate = (rowData) => {
    return <div>{ISOLogoTemplate(rowData.iso)} </div>;
  };

  const authorTemplate = (rowData) => {
    let res = rowData["surname"];
    if (rowData["first-name"]) {
      res += `, ${rowData["first-name"]}`;
    }
    return res;
  };

  return (
    <DataTable
      value={data}
      responsiveLayout="scroll"
      header={header1}
      filters={filters1}
      filterDisplay="menu"
      paginator={longDescription}
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate="{first} to {last} of {totalRecords} results"
      rows={10}
      rowsPerPageOptions={[10, 20, 50, 100]}
    >
      <Column field="date" header="Date" sortable></Column>
      <Column field="title-original" header="Original title" sortable></Column>
      <Column
        field="author"
        header="Author"
        body={authorTemplate}
        sortable
      ></Column>
      {longDescription && (
        <Column field="language" header="Language" sortable></Column>
      )}
      {longDescription && (
        <Column field="publication" header="Publication" sortable></Column>
      )}
      {longDescription && (
        <Column field="link" header="Link" body={LinkTemplate}></Column>
      )}
      {longDescription && (
        <Column
          field="country"
          header="Country"
          body={IndexISOLogoTemplate}
        ></Column>
      )}
    </DataTable>
  );
};

export default IndexTable;
